import {
  PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
} from 'features/pii/const';
import { address } from 'helpers';
import { Fade } from 'helpers/animation';
import useFormInput from 'hooks/form/useFormInput';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import styled from 'styled-components';
import { paragraph500Mixin, scrollbarThumbMixin } from 'styles';
import FormInputAddressPostcodeValidation from '../FormInputAddressPostcodeValidation';

const CustomAddressPostcodeDropdown = ({
  field,
  information,
  setInformation,
  validation,
  setValidation,
}) => {
  const [postcodeSuggestion, setPostcodeSuggestion] = useState(null);

  const { setInformationFormInput, setValidationFormInput } =
    useFormInput(field);

  const handleDropdownItemSelected = (e, postcodeSelected) => {
    e.preventDefault();

    const { postcode, locality, state } = postcodeSelected || {};

    let newInformation = setInformationFormInput({
      value: postcode,
      information,
      setInformation,
    });
    newInformation = {
      ...newInformation,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME]: locality,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME]: state,
    };
    newInformation = {
      ...newInformation,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME]: address.addressCombine(
        newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME],
        newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME],
        newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME],
        newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME]?.key,
        newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME],
        newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME],
        newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME]
      ),
    };
    setInformation(newInformation);

    setValidationFormInput({
      validation,
      setValidation,
      isReset: true,
    });

    setPostcodeSuggestion(null);
  };

  const renderPostcodeSuggestionDropdown = () => {
    if (isEmpty(postcodeSuggestion)) return null;
    return (
      <DropdownMenu show={true}>
        {postcodeSuggestion?.map((postcode, index) => (
          <DropdownItem
            key={postcode.fullAddress}
            eventKey={index + 1}
            onClick={(e) => handleDropdownItemSelected(e, postcode)}
          >
            {`${postcode.postcode} (${postcode.locality} ${postcode.state})`}
          </DropdownItem>
        ))}
      </DropdownMenu>
    );
  };

  return (
    <CustomAddressPostcodeDropdownStyled>
      <FormInputAddressPostcodeValidation
        field={field}
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        postcodeSuggestion={postcodeSuggestion}
        setPostcodeSuggestion={setPostcodeSuggestion}
      />
      {renderPostcodeSuggestionDropdown()}
    </CustomAddressPostcodeDropdownStyled>
  );
};

const CustomAddressPostcodeDropdownStyled = styled.div`
  position: relative;
  width: 100%;
  ${Fade};
`;
const DropdownMenu = styled(Dropdown.Menu)`
  padding: 0;
  border: none;
  box-shadow: var(--ds-bs-4);
  max-height: 160px;
  border-radius: 0.375rem;
  width: 100%;
  overflow: auto;
  background: var(--ds-c-white);
  inset: 0px auto auto 0px !important;
  transform: translate(0px, 72px) !important;

  ${scrollbarThumbMixin};
`;
const DropdownItem = styled(Dropdown.Item)`
  ${paragraph500Mixin};
  display: flex;
  align-items: center;
  padding: 10px;
  text-transform: uppercase;
  min-height: 40px;
  height: fit-content;
  white-space: break-spaces;
  background: var(--ds-c-white);

  a:first-child {
    border-radius: 0.375rem 0.375rem 0 0;
  }

  &:hover {
    background: var(--ds-c-grey-light);
  }

  &:active {
    color: var(--ds-c-grey-dark);
  }
`;

export default CustomAddressPostcodeDropdown;
